// Welle 119 — gemeinsame Hilfen der Seite „Rechnungen" (Rechnung schreiben, Ausgangsbuch, Arbeitszeit-Auswahl)
import { API_BASE } from "../../api/config";

export const API = `${API_BASE}/mietverwaltung/api/rechnung`;

export const zahl = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return v;
  const s = String(v).trim().replace(/\s/g, "").replace(/€/g, "");
  const n = s.includes(",") ? Number(s.replace(/\./g, "").replace(",", ".")) : Number(s);
  return Number.isFinite(n) ? n : 0;
};

export const euro = (v) => `${(Math.round(zahl(v) * 100) / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const deDatum = (iso) => (iso ? String(iso).slice(0, 10).split("-").reverse().join(".") : "");

export async function json(r) {
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || `Fehler ${r.status}`);
  return d;
}

// Welle 120: Anrede steht in einem eigenen Feld — aus Bausteinen/Texten die führende Anrede-Zeile entfernen
const ANREDE_RX = /^\s*(sehr geehrte|liebe|lieber|hallo|guten tag)\b[^\n]*\n*/i;
export const ohneAnrede = (text) => String(text || "").replace(ANREDE_RX, "").trim();

// Welle 121: Datei aus der Dropbox (Batch Output, Anlagen) im neuen Tab zeigen bzw. herunterladen
export async function dropboxDatei(pfad, herunterladen = false) {
  const r = await fetch(`${API}/datei?pfad=${encodeURIComponent(pfad)}`);
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Datei nicht gefunden (schon verschoben?)");
  const url = URL.createObjectURL(await r.blob());
  if (herunterladen) {
    const a = document.createElement("a");
    a.href = url; a.download = String(pfad).split("/").pop();
    document.body.appendChild(a); a.click(); a.remove();
  } else {
    window.open(url, "_blank");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
